import { Feather } from "@expo/vector-icons";
import { Q } from "@nozbe/watermelondb";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Card,
  Divider,
  Page,
  PayTypeToIcon,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useEffect, useState } from "react";
import { FlatList } from "react-native";
import { CASH_PAY_TYPE_ID } from "../../../../constants";
import { SettingsRootParamList } from "../../../../types";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { SelectablePaymentMethodButton } from "../../../point-of-sale/screens/SelectPaymentMethodScreen/components/SelectablePaymentMethodButton";

export type EditCashManagedPaymentMethodScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "EditCashManagedPaymentMethodScreen"
>;

export const EditCashManagedPaymentMethodScreen = ({
  navigation,
}: EditCashManagedPaymentMethodScreenProps) => {
  const globalSettings = useGlobalSettingsProvider();
  const database = useDatabase();
  const { colors } = useThemeProvider();
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();

  useEffect(() => {
    database
      .get<PaymentMethod>("payment_methods")
      .query(
        Q.where("enabled", true),
        Q.on("pay_types", "internal", Q.eq(false)),
        Q.where("deleted_at", Q.eq(null)),
        Q.where("paytype_id", Q.eq(CASH_PAY_TYPE_ID))
      )
      .fetch()
      .then(setPaymentMethods)
      .catch((e) => console.log(e));
  }, []);

  const handleOnItemPressed = async (id: string) => {
    return updateGlobalSettings({
      cashManagedPaymentMethodId: id,
    })
      .then(navigation.goBack)
      .catch(console.log);
  };

  const renderItem = ({ item }: { item: PaymentMethod }) => {
    const selected = globalSettings.cashManagedPaymentMethodId === item.id;
    return (
      <SelectablePaymentMethodButton
        onPress={() => handleOnItemPressed(item.id)}
        label={item.name}
        selected={selected}
        icon={<PayTypeToIcon payType={item.payType.id} />}
        componentRight={() => {
          return selected ? (
            <Feather name="check" size={24} color={colors.primary} />
          ) : null;
        }}
      />
    );
  };

  return (
    <Page title="Select Cash Managed Payment Method">
      <Card>
        <FlatList
          ItemSeparatorComponent={Divider}
          renderItem={renderItem}
          data={paymentMethods}
          scrollEnabled={true}
        ></FlatList>
      </Card>
    </Page>
  );
};
